/**
 * Grid breakpoints
 * Define the minimum dimensions at which your layout will change,
 * adapting to different screen sizes, for use in media queries.
 */
export var gridBreakpoints = {
  xs: 320,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200
};
var screen = {
  xsMin: "".concat(gridBreakpoints.xs, "px"),
  xsMax: "".concat(gridBreakpoints.sm - 1, "px"),
  smMin: "".concat(gridBreakpoints.sm, "px"),
  smMax: "".concat(gridBreakpoints.md - 1, "px"),
  mdMin: "".concat(gridBreakpoints.md, "px"),
  mdMax: "".concat(gridBreakpoints.lg - 1, "px"),
  lgMin: "".concat(gridBreakpoints.lg, "px"),
  lgMax: "".concat(gridBreakpoints.xl - 1, "px"),
  xlMin: "".concat(gridBreakpoints.xl, "px")
};
export default screen;